import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type EnterpriseAdminsFragment = (
  { __typename: 'Enterprise' }
  & Pick<Types.Enterprise, 'id' | 'idAdmins'>
);

export const EnterpriseAdminsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnterpriseAdmins' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Enterprise' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'idAdmins' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseEnterpriseAdminsFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      EnterpriseAdminsFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseEnterpriseAdminsFragmentResult
  extends Omit<Apollo.UseFragmentResult<EnterpriseAdminsFragment>, 'data'> {
  data?: EnterpriseAdminsFragment;
}

export const useEnterpriseAdminsFragment = ({
  from,
  returnPartialData,
  ...options
}: UseEnterpriseAdminsFragmentOptions): UseEnterpriseAdminsFragmentResult => {
  const result = Apollo.useFragment<EnterpriseAdminsFragment>({
    ...options,
    fragment: EnterpriseAdminsFragmentDoc,
    fragmentName: 'EnterpriseAdmins',
    from: {
      __typename: 'Enterprise',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Fragment data is incomplete.', result);
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as EnterpriseAdminsFragment };
};
